// To Do > History: every closed item, newest closed first, with the same filter pills plus closed date range and closed by.
// Columns: closed, title, type, department, component, location, responsible, closed by, days open; Reopen on each row.
// Export Excel / PDF of what is shown ("Engineering defects closed in October 2026"). Rules: src/lib/todoWork.js.
import { useEffect, useState } from 'react'
import TodoFilterBar, { PillSelect, TodoFilterChips, filterChips } from './TodoFilterBar'
import DateField from './DateField'
import { HISTORY_RANGES, TYPE_TABS, applyFilters, closedRange, historyItems, historyRows, historyTitle, daysOpen, typeOf, locationOf, responsibleOf, dayOf, filtersActive } from '../lib/todoWork'

const RKEY = who => 'hc_todo_history:' + (who || 'anon')
function loadRange(who) {
  try { const v = JSON.parse(localStorage.getItem(RKEY(who)) || 'null'); return v && typeof v === 'object' ? { range: String(v.range || ''), from: String(v.from || ''), to: String(v.to || ''), closedBy: String(v.closedBy || '') } : null } catch (e) { return null }
}
const fmt = d => (d ? new Date(d + 'T12:00:00').toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '')

export default function TodoHistory({ who, today, items, filters, setFilter, clearFilters, options, names, onOpen, onReopen, onExport, canWrite }) {
  const [saved] = useState(() => loadRange(who) || { range: '', from: '', to: '', closedBy: '' })
  const [range, setRange] = useState(saved.range)
  const [custom, setCustom] = useState({ from: saved.from, to: saved.to })
  const [closedBy, setClosedBy] = useState(saved.closedBy)
  const [exportOpen, setExportOpen] = useState(false)
  useEffect(() => { try { localStorage.setItem(RKEY(who), JSON.stringify({ range, ...custom, closedBy })) } catch (e) { /* not remembered */ } }, [range, custom, closedBy, who])

  const r = closedRange(range, today, custom)
  const closed = historyItems(items, { from: r.from, to: r.to, closedBy })
  const f = { ...filters, status: 'all' }
  const preType = applyFilters(closed, { ...f, type: '' }, names)
  const rows = f.type ? preType.filter(i => typeOf(i) === f.type) : preType
  const typeTabs = TYPE_TABS.map(([v, label]) => ({ value: v, label, count: v ? preType.filter(i => typeOf(i) === v).length : preType.length }))
  const people = [...new Set(historyItems(items).map(i => i.closed_by).filter(Boolean))].sort()
  const title = historyTitle(f, r)
  const anyOn = filtersActive({ ...filters, status: 'open' }) || !!range || !!closedBy
  const clearHistory = () => { clearFilters(); setRange(''); setCustom({ from: '', to: '' }); setClosedBy('') }

  return (
    <div className="tdh-scope">
      <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap', marginBottom: 14 }}>
        <div>
          <div className="tdh-sub">{title} · {rows.length} item{rows.length === 1 ? '' : 's'}</div>
        </div>
        <span className="tdf" style={{ display: 'contents' }}>
          <span className="tdf-pill-wrap">
            <span className="tdf-pill"><button type="button" className="tdf-pill-main" aria-haspopup="menu" aria-expanded={exportOpen} disabled={!rows.length} onClick={() => setExportOpen(v => !v)}>Export</button></span>
            {exportOpen && (
              <div className="tdf-menu right" role="menu" onMouseLeave={() => setExportOpen(false)}>
                <button type="button" role="menuitem" className="tdf-opt" onClick={() => { setExportOpen(false); onExport('xlsx', historyRows(rows, names), title) }}><span className="tdf-opt-check" />Excel (.xlsx)</button>
                <button type="button" role="menuitem" className="tdf-opt" onClick={() => { setExportOpen(false); onExport('pdf', historyRows(rows, names), title) }}><span className="tdf-opt-check" />PDF (owner / management report)</button>
              </div>
            )}
          </span>
        </span>
      </div>

      <TodoFilterBar filters={f} setFilter={setFilter} typeTabs={typeTabs} showList hideStatus options={options} anyOn={anyOn} clearAll={clearHistory} resultCount={rows.length} keyHint="/"
        extraCount={(range ? 1 : 0) + (closedBy ? 1 : 0)}
        extra={<>
          <div><div className="tdf-cap">Closed date</div><PillSelect label="Closed date" placeholder="Any" value={range} onChange={setRange} options={HISTORY_RANGES.map(([value, label]) => ({ value, label }))} /></div>
          <div><div className="tdf-cap">Closed by</div><PillSelect label="Closed by" placeholder="Anyone" align="right" value={closedBy} onChange={setClosedBy} options={people.map(p => ({ value: p, label: p }))} /></div>
        </>} />
      <TodoFilterChips clearAll={clearHistory} chips={[...filterChips(f, setFilter, { options, showList: true, hideStatus: true }),
        ...(range ? [{ key: 'range', label: 'Closed date', value: (HISTORY_RANGES.find(([v]) => v === range) || [])[1] || range, onRemove: () => setRange('') }] : []),
        ...(closedBy ? [{ key: 'closedBy', label: 'Closed by', value: closedBy, onRemove: () => setClosedBy('') }] : [])]} />
      {range === 'custom' && (
        <div className="tdf" style={{ flexDirection: 'row', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginTop: -4 }}>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>Closed from</span>
          <span style={{ width: 150 }}><DateField value={custom.from} onChange={v => setCustom(c => ({ ...c, from: v || '' }))} /></span>
          <span style={{ fontSize: 12, color: 'var(--muted)' }}>to</span>
          <span style={{ width: 150 }}><DateField value={custom.to} onChange={v => setCustom(c => ({ ...c, to: v || '' }))} /></span>
        </div>
      )}

      <div className="tdh-wrap">
        <table className="tdh">
          <thead><tr><th>Closed</th><th>Title</th><th>Type</th><th>Department</th><th>Component</th><th>Location</th><th>Responsible</th><th>Closed by</th><th className="num">Days open</th><th aria-label="Reopen" /></tr></thead>
          <tbody>
            {rows.map(i => {
              const d = daysOpen(i)
              return (
                <tr key={i.id} onClick={() => onOpen(i)}>
                  <td className="nowrap" data-label="Closed">{fmt(dayOf(i.closed_at)) || '—'}</td>
                  <td className="title">{i.text}</td>
                  <td data-label="Type"><span className={'td-badge ' + typeOf(i).toLowerCase()}>{typeOf(i)}</span></td>
                  <td data-label="Department">{i.department || ''}</td>
                  <td data-label="Component">{names.equipment(i.equipment_id) || ''}</td>
                  <td data-label="Location">{locationOf(i, names.zone)}</td>
                  <td data-label="Responsible">{responsibleOf(i)}</td>
                  <td data-label="Closed by">{i.closed_by || ''}</td>
                  <td className="num" data-label="Days open">{d == null ? '' : d}</td>
                  <td className="act">{canWrite && <button type="button" className="tdh-reopen" onClick={e => { e.stopPropagation(); onReopen(i) }}>Reopen</button>}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
        {!rows.length && <div style={{ padding: '22px 8px', textAlign: 'center', fontSize: 13, color: 'var(--muted)' }}>{closed.length || anyOn ? 'Nothing closed matches these filters.' : 'Nothing closed yet.'}</div>}
      </div>
    </div>
  )
}
